<template>
  <div>
    <!--底部-->
    <div id="footer">
      <hr>
      <div class="detailList">
        <div v-for="(item,index) in detailList" :key="index">
          <ul>
            <li><h1>{{item.h1}}</h1></li>
            <li><h2>{{item.h2}}</h2></li>
            <li>
              <h4 v-for="(list,listIndex) in item.h4" @click="jumpToTarget(index,listIndex)">
                <a @click="backTop">{{list}}</a>
              </h4>
            </li>
            <li><h3>{{item.h3}}</h3></li>
            <li><h5>{{item.h5}}</h5></li>
          </ul>
        </div>
      </div>
      <a class="footer_message" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
        <img src="https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/public/footer_logo.png" class="img-responsive">
        <span>©2015-2019 付帅 粤ICP备15093103号</span>
      </a>
    </div>
    <!--/底部-->
  </div>
</template>

<script>
    import './../assets/css/fy_footer.css'
    import detailList from "../assets/conf/footer"
    import click from "../js/clickTab"

    export default {
        name: "fy_footer",
        data() {
            return {
                tabbarTitle: [
                    [],
                    ['付帅云收银','自助点餐','自主外卖','扫码购'],
                    ['付帅收款码','云播报','扫码机具','云打印','更多硬件'],
                    ['FY010A云喇叭','FY010B云喇叭','FY010C云音箱','FY100云音箱','FY070打印机'],
                    []
                ],
                detailList: detailList
            }
        },
        methods: {
            // 选择产品的下标
            jumpToTarget(index,listIndex) {
              if(index === 1) {
                  if(this.$route.name !== 'software') {
                      this.$router.push({
                          name: 'software',
                          params: {
                              page: listIndex
                          }
                      })
                  }
                  this.$cookies.set('selectedTitle',index,'1d','/')
                  this.$store.dispatch('chooseTitle',{index: 1})
              }
              if(index === 2) {
                  if(this.$route.name !== 'hardware') {
                      this.$router.push({
                          name: 'hardware',
                          params: {
                              page: listIndex
                          }
                      })
                  }
                  this.$cookies.set('selectedTitle',index,'1d','/')
                  this.$store.dispatch('chooseTitle',{index: 2})
              }
              click(listIndex)
            },
            // 点击图片回到顶部方法，加计时器是为了过渡顺滑
            backTop () {
                document.documentElement.scrollTop = document.body.scrollTop = 0
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_footer.vue